import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pageBack" }
const _hoisted_2 = { class: "detail_en" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "detail_pro" }
const _hoisted_5 = { style: {"font-size":"24px"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { style: {"color":"#9A9A9A"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "detail_pro" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "submit" }, [
  /*#__PURE__*/_createElementVNode("label", null, "管理员回复")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "detail_pro" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "",
      "left-text": "",
      onClickLeft: _ctx.onClickLeft
    }, null, 8, ["onClickLeft"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.exposure.feedbackTitle), 1)
      ]),
      _hoisted_6,
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.exposure.feedbackTime), 1)
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", null, _toDisplayString(_ctx.exposure.feedbackContent), 1)
      ]),
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("label", null, _toDisplayString(_ctx.exposureAnswer.feedbackAnsContent), 1)
      ])
    ])
  ]))
}